
import { Component, Vue, Prop, Watch, Emit, Mixins } from 'vue-property-decorator'
import LazyImg from '@xt/www/components/lazyImg/index.vue'
import Qrcode from '@xt/www/components/showQrcode/index.vue'
import { MixinsHomeClick } from '@xt/client/mixins/home'
import { openMiniProgram } from '@xt/client/utils/mini'
import { EnumOpenMiniProgramType } from '@xt/client/enums/mini'
import { JumpMiniEvent } from '@xt/client/types/home'

type DayCourseItem = {
  cover: string
  title: string
  vice: string
  event?: JumpMiniEvent
}

@Component({
  components: {
    Qrcode,
    LazyImg
  }
})
export default class DayHeadCard extends Mixins(MixinsHomeClick) {
  @Prop() dataSource: Array<DayCourseItem>

  async handleOpenPCMini(item: DayCourseItem) {
    if (!item.event) return

    const { success, reason } = await openMiniProgram(EnumOpenMiniProgramType.DayCourse, item.event.path)

    console.warn(success, reason)

    if (reason) {
      this.$message.error(reason)
    }
  }

  handleClick(item: DayCourseItem) {
    if (item.event) {
      this.onClickEvent(item.event)
      return
    }
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
